type ConsentCategory = "necessary" | "preferences" | "statistics" | "marketing";

type CookiebotConsent = Partial<Record<ConsentCategory, boolean>>;

type CookiebotApi = {
  consent?: CookiebotConsent;
};

const hasWindow = (): boolean => typeof window !== "undefined";

const getCookiebot = (): CookiebotApi | null => {
  if (!hasWindow()) return null;
  return window.Cookiebot ?? null;
};

export const hasConsent = (category: ConsentCategory): boolean => {
  const cookiebot = getCookiebot();
  return cookiebot?.consent?.[category] === true;
};

export const onConsentGranted = (
  category: ConsentCategory,
  callback: () => void
): (() => void) => {
  if (hasConsent(category)) {
    callback();
    return () => undefined;
  }

  if (!hasWindow()) {
    return () => undefined;
  }

  const handler = () => {
    if (hasConsent(category)) callback();
  };

  window.addEventListener("CookiebotOnAccept", handler as EventListener);
  window.addEventListener("CookiebotOnDeclaration", handler as EventListener);

  return () => {
    window.removeEventListener("CookiebotOnAccept", handler as EventListener);
    window.removeEventListener(
      "CookiebotOnDeclaration",
      handler as EventListener
    );
  };
};
